import { Component, OnInit } from '@angular/core';
import { TrialToaster } from './trial-toaster';
import { TrialToasterService } from '../../services/trial-toaster.service';

@Component({
    selector: 'trial-toaster',
    templateUrl: 'trial-toaster.component.html'
})
export class TrialToasterComponent implements OnInit  {
    public toaster: TrialToaster;

    constructor(private trialToasterService: TrialToasterService) { }

    public ngOnInit(): void {
        this.trialToasterService.getToaster().subscribe((toast: TrialToaster) => {
            const toasterActive = sessionStorage.getItem('trialToaster');
            if (!toast || toasterActive === 'false') {
                this.toaster = null;
                return;
            }
            this.toaster = toast;
        });
    }

    public removeAlert(): void {
        this.toaster = null;
        sessionStorage.setItem('trialToaster', 'false');
    }

    public getTitle(toast: TrialToaster): string {
        if (!toast) {
            return;
        }

        if (toast.title) {
            return toast.title;
        }
    }
}
